import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { loadPermissionsService } from '../../services/load-permissions/index.tsx';
import { LOAD_APP_DATA_REQUEST } from '../../state/actions/app/index.tsx';
import {
	fetchPermissionsFailure,
	fetchPermissionsSuccess,
} from '../../state/actions/permissions/index.tsx';
import { getRapidViewId } from '../../state/selectors/app/index.tsx';
import type { ActionsObservable, MiddlewareAPI } from '../../state/types.tsx';

const loadPermissions = ({ store }: { store: MiddlewareAPI }) => {
	const state = store.getState();
	const boardId = getRapidViewId(state);

	return loadPermissionsService(boardId)
		.map(fetchPermissionsSuccess)
		.catch((error) => {
			log.safeErrorWithoutCustomerData(
				'backlog.load-permission.failure',
				'Failed to fetch permissions for Company-Managed backlog',
				error,
			);
			return Observable.of(fetchPermissionsFailure());
		});
};

export const loadPermissionsEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(LOAD_APP_DATA_REQUEST).flatMap(() => loadPermissions({ store }));
